import { CommentaryRepository } from '@/domain/repositories/commentary/CommentaryRepository'
import { Commentary } from '@/domain/value_objects/commentary/Commentary'
import { ApiClients } from '@/infrastructure/clients/apiClients'

export class CommentaryRepositoryImpl implements CommentaryRepository {
  constructor(private clients: ApiClients) {}

  async getCommentary(
    displayLanguage: string,
    problemId: string,
    pattern: string,
    type: string,
    filter: string
  ): Promise<Commentary> {
    const path = `resources/commentaries/${displayLanguage}/${problemId}/${pattern}/${type}/${filter}`
    const data = (await this.clients.aojClient.fetch(path)) as any
    return {
      createdAt: data.created_at,
      filter: data.filter,
      html: data.html,
      language: data.language,
      pattern: data.pattern,
      problemId: data.problem_id,
      type: data.type
    }
  }
}
